import _ from 'lodash';
import React from 'react';
import { CompressGroupContainer } from './operation-groups/compress-group/compress-group.container';
import { DownloadGroupContainer } from './operation-groups/download-group/download-group.container';
import {
  OperationGroup,
  OperationGroupType,
} from './operation-groups/operation-groups.types';
import { UploadGroupContainer } from './operation-groups/upload-group/upload-group.container';
import { OperationPanelPosition } from './operation-panel-position/operation-panel-position';
import styles from './operation-panel.scss';

interface GroupProps {
  group: OperationGroup;
}

const Group: React.FunctionComponent<GroupProps> = ({ group }: GroupProps) => {
  switch (group.type) {
    case OperationGroupType.Upload:
      return <UploadGroupContainer key={group.id} groupId={group.id} />;

    case OperationGroupType.MultipleDownload:
      return <DownloadGroupContainer key={group.id} groupId={group.id} />;

    case OperationGroupType.Compress:
      return <CompressGroupContainer key={group.id} groupId={group.id} />;

    default:
      return null;
  }
};

interface Props {
  operationGroupsList: OperationGroup[];
}

export const OperationPanel: React.FunctionComponent<Props> = ({
  operationGroupsList,
}: Props) => {
  if (operationGroupsList.length === 0) {
    return null;
  }

  return (
    <OperationPanelPosition>
      {_.chain(operationGroupsList)
        .reverse()
        .map((group) => (
          <div key={group.id} className={styles.groupWrapper}>
            <Group group={group} />
          </div>
        ))
        .value()}
    </OperationPanelPosition>
  );
};
